export default __webpack_public_path__ + "static/media/1261.4a874c1d.png";